export const MainMenu = [
  {
    title: 'Solutions',
    cName: 'navText',
    position: 0,

    subMenu: [
      {
        title: 'Assist Platform',
        path: '/platform/',
        cName: 'dropdownLink',
      },
      {
        title: 'Stim Assist',
        path: '/stim-assist/',
        cName: 'dropdownLink',
      },
      {
        title: 'Embryo Assist',
        path: '/embryo-assist/',
        cName: 'dropdownLink',
      },
      {
        title: 'Success Predictor',
        path: '/success-predictor',
        cName: 'dropdownLink',
      },
    ],
  },
  {
    title: 'Resources',
    cName: 'navText',
    position: 1,

    subMenu: [
      {
        title: 'Research',
        path: '/research/',
        cName: 'dropdownLink',
      },
      {
        title: 'Press & News',
        path: '/press/',
        cName: 'dropdownLink',
      },
    ],
  },
  {
    title: 'Contact',
    cName: 'navText',
    position: 2,

    subMenu: [
      {
        title: 'Talk to Sales',
        path: '/request-a-demo/',
        cName: 'dropdownLink',
      },
      {
        title: 'Customer Support',
        path: '/contact/',
        cName: 'dropdownLink',
      },
    ],
  },
];
